//функция подстановки нуля к однозначному числу [function of adding zero for a single digit]
const twoDigitFormat = ( value ) => ( value < 10 ) ? `0${ value }` : value;
export default twoDigitFormat;